module.exports = __webpack_public_path__ + "static/media/btn_shroom_active.2205a748.png";